import { msalScopes, authConfig } from './msal'
import type { CustomerAccountMsal } from '@/types/msal'

interface EnvironmentConfig {
  apiUrl: string
  apiVersion: string
  msal: CustomerAccountMsal
}

const getAppEnvironment = (): EnvironmentConfig => {
  const config = useRuntimeConfig()

  // Get values from runtime config (populated from Azure Key Vault via pipeline)
  const clientId = config.public.AZURE_AD_ADMIN_CLIENT_ID
  const apiScope = config.public.AZURE_AD_ADMIN_API_SCOPE

  // Use API_BASE from runtime config if available, fallback to default
  const apiUrl = config.public.API_BASE || 'https://epicustomeraccountorchestrator-np.azurewebsites.net/api'
  const apiVersion = config.public.API_VERSION || 'v1'

  // Construct absolute redirect URI (required by Azure AD OAuth)
  // Use window.location.origin if available (client-side), otherwise default to localhost
  const redirectUri = typeof window !== 'undefined' ? `${window.location.origin}/` : 'http://localhost:3000/'

  return {
    apiUrl,
    apiVersion,
    msal: {
      auth: {
        ...authConfig,
        clientId: clientId,
        redirectUri: redirectUri
      },
      cache: authConfig.cache,
      scopes: [...msalScopes, apiScope]
    }
  }
}

export { getAppEnvironment }
